module.exports = __webpack_public_path__ + "img/global.e88e90cb.png";